export const RARITY_COLORS = {
  CONSUMER_GRADE: "#B0C3D9",
  INDUSTRIAL_GRADE: "#5E98D9",
  MIL_SPEC_GRADE: "#4b69ff",
  RESTRICTED: "#8847ff",
  CLASSIFIED: "#d32ce6",
  COVERT: "#eb4b4b",
  CONTRABAND: "#FFD700",
  EXTRAORDINARY: "#FFD700",
  EXOTIC: "#FFD700",
  HIGH_GRADE: "#5E98D9",
  REMARKABLE: "#8847ff",
  SUPERIOR: "#eb4b4b",
  MASTER: "#FFD700",
  BASE_GRADE: "#B0C3D9",
  DISTINGUISHED: "#FFD700",
  EXCEPTIONAL: "#d32ce6",
} as const;

export type RarityGrade = keyof typeof RARITY_COLORS;